// extracted by mini-css-extract-plugin
export default {"checkbox":"AddSubcontractorModal_checkbox__tUq0w","newContactPerson":"AddSubcontractorModal_newContactPerson__WPnlH","open":"AddSubcontractorModal_open__ndNDj"};